import { AxiosInstance } from "axios"

import { BillReceiversItem } from "./billReceiversTypes"

export enum BillReceiversQuery {
    LIST = "bill-receivers-for-company",
}

export type AccountingBillReceiversParams = Readonly<{
    companyId: number
    search?: string
}>

export type AccountingBillReceiversResponse = Readonly<{
    billReceivers: BillReceiversItem[]
}>

export async function fetchAccountingBillReceivers(
    { companyId, search }: AccountingBillReceiversParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<AccountingBillReceiversResponse> {
    const url = `/companies/${companyId}/accounting/billReceivers`
    const { data } = await axios.get(url, {
        signal,
        params: {
            search,
        },
    })

    return data
}
